import {
  FETCH_USER,
  USER_CLICK_HELLO,
  FETCH_USER_PROFILE_URL,
  OPEN_UPDATE_SKILLS,
  CLOSE_UPDATE_SKILLS,
  USER_CLICK_PROFILE_EDIT,
  USER_PROFILE_EDIT_DONE,
  RESET_JOBS,
  MARK_SKILLS_UPDATED,
  BLACKLIST_OCC,
  SET_BLACKLIST,
  ADD_NEW_SKILL,
  UPDATE_CHAT_SKILLS,
  SET_NOTIFICATION,
  SET_NOTIFICATION_AMOUNT,
  SET_USER_PERMISSIONS,
  SET_SKILLS,
  UPDATE_DEMOGRAPHICS,
  UPDATE_DEMOGRAPHICS_QUESTIONS,
  OPEN_DEMOGRAPHICS,
  FETCH_INTERNAL_MOBILITY_ROLES,
  FETCH_INTERNAL_MOBILITY_QUALIFICATIONS,
  HIDE_AA_HELP_TEXT,
  JOBS_FILTER,
  SET_COMPLETED_SKILLS_ASSESSMENTS,
  SET_PROJECTED_SKILS,
  SET_VALIDATION_REQUESTS,
  SET_SKILL_NOTIFICATION,
  SET_SKILLS_ASSESSMENTS_ERRORS,
  FETCH_PROJECTS,
  SET_QUALIFICATIONS, 
} from "./types";
import { logout, validateUserSession } from "./auth_actions";
import {checkOrders, fetchCoins} from "./reward_actions";
import { updateEndpointFunc, recordSkillUpdate } from "./analytics_actions";
import { fetchSkillsInfo, preLoadJobsSearch, toggleLoading, addOccupationFilter, fetchQualifications, fetchCertifications} from "./job_actions";
import { resetMessages, sendMessage } from "./chat_actions";
import _ from "lodash";
import config from "../config/";
import { post, get, put, del } from "./api";
import { Cache, ConsoleLogger } from "aws-amplify/utils";
import { getUrl } from "aws-amplify/storage";
const logger = new ConsoleLogger("userActions");

// Cognito - Auth.signIn()
export function fetchUser(onlyUser = false) {
  return async function (dispatch, getState) {

    try {
      let data = await get(`/users`);

      if (data === false){
        return false;
      }
      //console.log(data);
      if (data.userID) {
        const clickedHello = await Cache.getItem("clickedHello");
        dispatch({ type: FETCH_USER, user: { ...data, clickedHello: !!clickedHello } });
        dispatch({ type: SET_BLACKLIST, newBlackList:data.occupationBlacklist });
        if (data.assessmentCompleted){
          await Promise.all([dispatch(fetchSkillsInfo())]);
        }
        if (!onlyUser) {
          dispatch(fetchProfileURL());
          dispatch(updateEndpointFunc());
          dispatch(getSkillAssessmentCompleted());
          dispatch(getSkillValidationRequests());
          dispatch(getProjectedSkills());
          dispatch(getProjectHistory());
          dispatch(checkOrders());
          dispatch(fetchCoins());
          dispatch(fetchCertifications())
        }

      } else {
        dispatch({ type: FETCH_USER, user: {} });
      }
    } catch (e) {
      logger.error("fetchUserDetails():", e);
      dispatch(logout());
      //dispatch({ type: FETCH_USER, user: {} });
    }
  };
}

export function fetchProfileURL() {
  return async function (dispatch) {
    var profileURL;
    try {
      const getUrlResult = await getUrl({
        path: ({identityId}) => `private/${identityId}/profile.png`,
      });
      profileURL = getUrlResult.url.href;
      dispatch({ type: FETCH_USER_PROFILE_URL, profileURL });
    } catch (e) {
      dispatch({ type: FETCH_USER_PROFILE_URL, profileURL: false });
      console.log(e);
    }
  };
}

export function clickHello() {
  return async function (dispatch) {
    Cache.setItem("clickedHello", true);
    dispatch({ type: USER_CLICK_HELLO });
  };
}

export function clickProfileEdit() {
  return async function (dispatch) {
    dispatch({ type: USER_CLICK_PROFILE_EDIT });
  };
}
export function doneProfileEdit() {
  return async function (dispatch) {
    dispatch({ type: USER_PROFILE_EDIT_DONE });
    dispatch({ type: RESET_JOBS });
    dispatch(preLoadJobsSearch())
  };
}

export function openUpdateSkills(key, skill) {
  return async function (dispatch) {
    dispatch({ type: OPEN_UPDATE_SKILLS, occkey: key, highlightSkill:skill });
  };
}
export function closeUpdateSkills(skipReset) {
  return async function (dispatch, getState) {
    const {
      user : {
        skillWasEdited
      }
    } = getState();

    await dispatch(fetchUser(true));
    dispatch({ type: CLOSE_UPDATE_SKILLS });
    dispatch(fetchCoins())
    //only if changed
    if (!skipReset && skillWasEdited && skillWasEdited === true){
      dispatch({ type: RESET_JOBS });
      dispatch(preLoadJobsSearch())
    }
    
  };
}


export function sendFeedback(description, id, _type) {
  return async function (dispatch) {
    await post(`/users/feedback`, { description: description, type: _type, id: id });
  }
}

export function saveSkills(occupation, skills, optionalSkills, deletedSkills, updatedSkills) {
  return async function (dispatch) {
    dispatch(recordSkillUpdate(occupation));
    try {
      const occ = await put(`/users/skills`, {
        occupation: occupation,
        skills: skills,
        optionalSkills: optionalSkills ? optionalSkills : [],
        deletedSkills: deletedSkills ? deletedSkills : [],
        updatedSkills: updatedSkills ? updatedSkills : []  //list of updatedSkills for coins + experties check
      });
      if (occ.data && occ.data && occ.data.occupationSkills){
        dispatch({ type: SET_SKILLS, occupationSkills: occ.data.occupationSkills });
      }

    } catch (e) {
      logger.error("saveSkills ():", e);
    }
    


    dispatch({ type: MARK_SKILLS_UPDATED});
    // dispatch(fetchCoins())
  };
}

export function addSkillsFromProfile(skills, groupPrefix) {
  return async function (dispatch, getState) {
    try {
      const { user: { occupationSkills }} = getState()
      let newOccupationSkills = _.cloneDeep(occupationSkills);
      let skillObjIdx = null
      let newSkillList = skills.map((item) => {return {"name": item, "level": 0}})

      occupationSkills.forEach(function (item, index) {
        if (item.occupation === (groupPrefix ? groupPrefix : "Manually Added: Skills")){
          skillObjIdx = index
        }
      });
      
      if(skillObjIdx !== null){
        newOccupationSkills[skillObjIdx].skills.push(...newSkillList)
        await dispatch(saveSkills(newOccupationSkills[skillObjIdx].occupation, newOccupationSkills[skillObjIdx].skills, newOccupationSkills[skillObjIdx].optionalSkills, newOccupationSkills[skillObjIdx].deletedSkills, skills))
      }
      else{
        skillObjIdx = newOccupationSkills.length
        newOccupationSkills.push({'occupation': groupPrefix ? groupPrefix : "Manually Added: Skills", 'expertise': "Beginner", 'skills': newSkillList, 'optionalSkills': [], 'deletedSkills':[]})
        await put(`/users/addSkill`, { ...newOccupationSkills[skillObjIdx], isNewSkill: true });
        dispatch({ type: MARK_SKILLS_UPDATED});
      }
      dispatch({ type: ADD_NEW_SKILL, newOccupationSkills, skillObjIdx });
    } catch (e) {
      logger.error("addSkillsFromProfile():", e);
    }
  }
}

export function fetchSkillDetails({skill, skillList=[], skillCategory}) {
  return async function (dispatch, getState) {
    const { user: { occupationSkills, showChat }} = getState()
    let newOccupationSkills = _.cloneDeep(occupationSkills);
    let skillObjIdx = null
    let newSkillList = [{"name": skill, "level": 0}]

    try {
      if (skillList && skillList.length){
        skillList.forEach((root_item) => {
          if (root_item.name.includes("(end)")){
            root_item.bottomLevelSkills.forEach((bottom_skill) => {
              newSkillList.push({"name": bottom_skill, "level": 0})
            })
          }
          else{
            newSkillList.push({"name": root_item.name, "level": 0})
          }
        })
      }
      newSkillList = _.uniqBy(newSkillList, 'name')
      occupationSkills.forEach(function (item, index) {
        if (item.occupation === "Manually Added: " + skillCategory){
          skillObjIdx = index
        }
      });

      if (skillObjIdx !== null){
        newOccupationSkills[skillObjIdx].skills.push(...newSkillList)
        dispatch(saveSkills(newOccupationSkills[skillObjIdx].occupation, newOccupationSkills[skillObjIdx].skills, newOccupationSkills[skillObjIdx].optionalSkills, newOccupationSkills[skillObjIdx].deletedSkills, [skill]))
      }
      else{
        skillObjIdx = newOccupationSkills.length
        newOccupationSkills.push({'occupation': "Manually Added: " + skillCategory, 'expertise': "Beginner", 'skills': newSkillList, 'optionalSkills': [], 'deletedSkills':[]})
        await put(`/users/addSkill`, { ...newOccupationSkills[skillObjIdx], isNewSkill: true });
      }
      dispatch({ type: ADD_NEW_SKILL, newOccupationSkills, skillObjIdx });
      // dispatch(fetchCoins())
      if(showChat){
        await dispatch({ type: UPDATE_CHAT_SKILLS, newOccupationSkills, skillObjIdx });
      }
    } catch (e) {
      logger.error("fetchSkillDetails():", e);
    }
  }
}

export const updateReverseMineIndexes = () => async (
  dispatch,
  getState
) => {
  const { 
    user: {
      provider,
      occupationSkills
    },
    jobs : {
      rawJobCategories
    }} = getState();
  if (rawJobCategories){
    let occupationSkillsFakeList = ""

    for (const skillType of occupationSkills) {
      for(const skillObject of skillType.skills){
        occupationSkillsFakeList = occupationSkillsFakeList + "#" + skillObject.name + "#"
      }
    }

    await put(`/users/updateRevMineIdxs`, {
      provider: provider,
      mineable_skills: occupationSkillsFakeList
    });
  }
}


export const updateOccupationBlacklist = (occupation, isRemove=false) => async (
  dispatch,
  getState
) => {
  dispatch(toggleLoading(true));
  if (occupation){
    await dispatch({ type: BLACKLIST_OCC, occupation:occupation, isRemove:isRemove });
  }
  else{
    await dispatch({ type: SET_BLACKLIST });
    Cache.removeItem("jobs")
  }
  
  const { jobs : { occupationBlacklist } } = getState();
  try {
    await put(`/users/occupationBlacklist`, { occupationBlacklist: occupationBlacklist });
  } catch (e) {
    logger.error("updateOccupationBlacklist ():", e);
  }
  if (occupation){
    dispatch(addOccupationFilter(occupation, isRemove ? false : true));
  }
  else{
    dispatch({ type: JOBS_FILTER, occupationCategoryFilterChange:true });
  }
  dispatch(toggleLoading(false));
  
};

export function deleteAccount() {
  return async function (dispatch) {
    try {
      await del(`/account`);
      dispatch(validateUserSession()); //console.log(data);
      window.location.replace("https://www.skillsminer.ai");
    } catch (e) {
      logger.error("deleteAccount ():", e);
    }
  };
}

export function enableNotification(enabled) {
  return async function (dispatch) {
    try {
      await post(`/account/notifications`, { enabled: enabled });
      dispatch(fetchUser(true)); //console.log(data);
    } catch (e) {
      logger.error("enableNotification ():", e);
    }
  };
}

export function enableCookies(enabled) {
  return async function (dispatch) {
    try {
      await post(`/account/cookie`, { enabled: enabled });
      dispatch({type: SET_USER_PERMISSIONS, enabled: enabled}); //console.log(data);
    } catch (e) {
      logger.error("enableNotification ():", e);
    }
  };
}


export function setNotification(goto) {
  return async function (dispatch){
    dispatch({type: SET_NOTIFICATION,
      goto: goto
    });
  }
}

export function setNotificationAmount(amount) {
  return async function (dispatch){
    dispatch({type: SET_NOTIFICATION_AMOUNT,
      notificationAmount: amount
    });
  }
}

export function submitDemographics(demoData) {
  return async function (dispatch, getState) {
    try {
      const { auth : { userID }, user: { showChat } } = getState();
      const data = await put(`/users/demographics`, demoData);
      if (data !== false) {
        await dispatch({type: UPDATE_DEMOGRAPHICS, demoData: data, showPage: false  });
        if(showChat){
          await Promise.all([dispatch(resetMessages())])          
        }
      }
    } catch (e) {
      logger.error("submitDemographics() error :", e);
    }
  };
}

export function showDemographics() {
  return async function (dispatch, getState) {
    const { user: { internalMobilityResponses, internalMobilityProvider } } = getState();
    dispatch({type: UPDATE_DEMOGRAPHICS, demoData: {}, showPage: true, IMdata:internalMobilityResponses});
    if(internalMobilityProvider){
      dispatch(getinternalMobilityDemographics());
    }
  };
}

export function setHideAAHelpText(storeChoice) {
  return async function (dispatch) {
    if(storeChoice){
      try {
        await post(`/user/applicationAssistant/hideHelp`, {});
      } catch (e) {
        logger.error("setHideAAHelpText ():", e);
      }
    }
    dispatch({type: HIDE_AA_HELP_TEXT });
  };
}

export function getinternalMobilityDemographics() {
  return async function (dispatch, getState) {
    try {
      const data = await get(`/users/internalMobilityDemographics`);
      if (data !== false && data.success) {
        await dispatch({type: UPDATE_DEMOGRAPHICS_QUESTIONS, data: data.data.questions, roles: data.roles, departments: data.departments, lineManagers: data.lineManagers, locations: data.locations});
      }
    } catch (e) {
      logger.error("getinternalMobilityDemographics() error :", e);
    }
  };
}


export function reOpenDemographics() {
  return async function (dispatch, getState) {
    try {
      await dispatch({type: OPEN_DEMOGRAPHICS});
    } catch (e) {
      logger.error("reOpenDemographics() error :", e);
    }
  };
}


export function getinternalMobilityRoles() {
  return async function (dispatch, getState) {
    try {
      const {
        user: { rawdata },
      } = getState();
      const data = await get(`/users/internalMobilityRoles`);
      if (data !== false && data.success) {
        const whiteListedOccs = rawdata && rawdata.desiredOccupations ? rawdata.desiredOccupations : []
        const filteredRoles = data.data.filter((item) => item.disabled && !whiteListedOccs.includes(item) ? false : true)
        await dispatch({type: FETCH_INTERNAL_MOBILITY_ROLES, data: filteredRoles});
        return filteredRoles
      }
    } catch (e) {
      logger.error("getinternalMobilityRoles() error :", e);
    }
  };
}

export function getinternalMobilityQualifications() {
  return async function (dispatch, getState) {
    try {
      const {
        user: { rawdata },
      } = getState();
      const data = await get(`/users/internalMobilityQuals`);
      if (data !== false && data.success) {
        await dispatch({type: FETCH_INTERNAL_MOBILITY_QUALIFICATIONS, data: data.data});
        return data.data
      }
    } catch (e) {
      logger.error("getinternalMobilityQualifications() error :", e);
    }
  };
}

export function submitDemographicsInternalMobility({questions, department, role, lineManager}) {
  return async function (dispatch, getState) {
    try {
      const { auth : { userID }, user: { showChat } } = getState();
      const data = await put(`/users/internalMobilityDemographics`, {
        questions: questions,
        department: department,
        role: role,
        lineManager: lineManager
      });
      if (data !== false) {
        let showPage = false;
        let holdUser = false;

        if(data.internalMobilityRoleVerified === "n"){
          holdUser = true;
          showPage = true
        }
        await dispatch({
          type: UPDATE_DEMOGRAPHICS, 
          demoData: {
            internalMobilityRole: data.internalMobilityRole,
            internalMobilityRoleVerified: data.internalMobilityRoleVerified,
            internalMobilityDepartment: data.internalMobilityDepartment,
            internalMobilityDepartmentVerified: data.internalMobilityDepartmentVerified,
            internalMobilityRoleDetails: data.internalMobilityRoleDetails,
            internalMobilityLineManager: data.internalMobilityLineManager,
            internalMobilityLineManagerVerified: data.internalMobilityLineManagerVerified,
            internalMobilityLineManagerDetails: data.internalMobilityLineManagerDetails,
          }, 
          showPage: showPage, 
          holdUser: holdUser,
          IMdata: data.internalMobilityResponses, 
        });
        if(showChat){
          await Promise.all([dispatch(resetMessages())])         
        }
      }
    } catch (e) {
      logger.error("submitDemographics() error :", e);
    }
  };
}

export function getSkillAssessmentCompleted() {
  return async function (dispatch, getState) {
    try {
      const data = await get(`/users/getSkillsAssessmentCompleted`);
      if (data !== false && data.success && data.data) {
        dispatch({type: SET_COMPLETED_SKILLS_ASSESSMENTS, data: data.data});
        if(data.errors){
          dispatch({type: SET_SKILLS_ASSESSMENTS_ERRORS, "data": data.errors})    
        }
      }
      else{
        dispatch({type: SET_COMPLETED_SKILLS_ASSESSMENTS, data: {}});
      }
    } catch (e) {
      logger.error("getSkillAssessmentCompleted() error :", e);
    }
  };
}

export function setSkillsAssessmentCompleted(assessment_data) {
  return async function (dispatch, getState) {
    try {
      const data = await post(`/users/setSkillsAssessmentCompleted`, {
        skill_name: assessment_data.skill_name,
        assessment_version: assessment_data.assessment_version,
        assessment_data: assessment_data.questions
      });
      if (data !== false && data.success && data.data) {
        dispatch({type: SET_COMPLETED_SKILLS_ASSESSMENTS, data: data.data});
        dispatch(setSkillValidationRequests(assessment_data.skill_name));
      }
      else{
        dispatch({type: SET_COMPLETED_SKILLS_ASSESSMENTS, data: {}});
      }
    } catch (e) {
      logger.error("setSkillsAssessmentCompleted() error :", e);
    }
  };
}


export function getSkillValidationRequests() {
  return async function (dispatch, getState) {
    try {
      const data = await post(`/users/skillvalidations/get`);
      if (data !== false && data.success) {
        dispatch({type: SET_VALIDATION_REQUESTS, completed: data.completed, requests:data.requests});
      }
      else{
        dispatch({type: SET_VALIDATION_REQUESTS, completed: [], requests:[]});
      }
    } catch (e) {
      logger.error("getSkillValidationRequests() error :", e);
    }
  };
}

export function setSkillValidationRequests(skill) {
  return async function (dispatch, getState) {
    try {
      const data = await post(`/users/skillsvalidations/set`, { skill: skill });
      if (data !== false && data.success) {
        dispatch({type: SET_VALIDATION_REQUESTS, completed: data.completed, requests:data.requests});
      }
      else{
        dispatch({type: SET_VALIDATION_REQUESTS, completed: [], requests:[]});
      }
    } catch (e) {
      logger.error("setSkillValidationRequests() error :", e);
    }
  };
}

export function getProjectedSkills() {
  return async function (dispatch, getState) {
    try {
      const data = await post(`/users/projectedskills/get`);
      if (data !== false && data.success) {
        dispatch({type: SET_PROJECTED_SKILS, read: data.read, unread:data.unread});
      }
      else{
        dispatch({type: SET_PROJECTED_SKILS, read: [], unread:[]});
      }
    } catch (e) {
      logger.error("getProjectedSkills() error :", e);
    }
  };
}

export function setProjectedSkills(skill) {
  return async function (dispatch, getState) {
    const { user: { occupationSkills=[] } } = getState();
    try {
      let targetOcc = false
      for (const occSkill of occupationSkills) {
        if(occSkill.skills.find((item) => item.name === skill) || (occSkill.optionalSkills && occSkill.optionalSkills.find((item) => item.name === skill)) ||(occSkill.deletedSkills && occSkill.deletedSkills.find((item) => item.name === skill))){
          targetOcc = occSkill.occupation
          break
        }
      }
      if(targetOcc){
        dispatch({type: SET_SKILL_NOTIFICATION, targetOcc: targetOcc, targetSkill:skill});
        dispatch(openUpdateSkills(targetOcc, skill))
      }

      const data = await post(`/users/projectedskills/set`, { skill: skill });
      if (data !== false && data.success) {
        dispatch({type: SET_PROJECTED_SKILS, read: data.read, unread:data.unread});
      }
      else{
        dispatch({type: SET_PROJECTED_SKILS, read: [], unread:[]});
      }
    } catch (e) {
      logger.error("setProjectedSkills() error :", e);
    }
  };
}

export function setSkillNotfiction(skill) {
  return async function (dispatch, getState) {
    try {
      if(skill){
        const { user: { occupationSkills=[] } } = getState();
        let targetOcc = false
        for (const occSkill of occupationSkills) {
          if(occSkill.skills.find((item) => item.name === skill) || (occSkill.optionalSkills && occSkill.optionalSkills.find((item) => item.name === skill)) ||(occSkill.deletedSkills && occSkill.deletedSkills.find((item) => item.name === skill))){
            targetOcc = occSkill.occupation
            break
          }
        }
        dispatch({type: SET_SKILL_NOTIFICATION, targetOcc: targetOcc, targetSkill:skill});
        dispatch(openUpdateSkills(targetOcc, skill))
      }
      else{
        dispatch({type: SET_SKILL_NOTIFICATION});
      }
    } catch (e) {
      logger.error("setSkillNotfiction() error :", e);
    }
  }
}

export function mapIdentity() {
  return async function (dispatch, getState) {
    try {
      await put(`/users/identitiymap`, {});
    } catch (e) {
      logger.error("mapIdentity() error :", e);
    }
  };
}

export function getProjectHistory() {
  return async function (dispatch, getState) {
    try {
      const data = await post(`/users/employeeProjects`);
      if (data !== false && data.data && data.success) {
        dispatch({type: FETCH_PROJECTS, data: data.data});
      }
    } catch (e) {
      logger.error("getProjectHistory() error :", e);
    }
  };
}

export function addQualSkills(qualObject) {
  return async function (dispatch, getState) {
    const { user: { qualifications=[] }} = getState()
    try {
      //append to qual list, 
      const newQualifications = [...qualifications, qualObject]
      const skillsList = qualObject.skills.map((item) => (item.name));
      await post(`/users/qualifications/set`, { qualifications: newQualifications });

      dispatch({type: SET_QUALIFICATIONS, data: newQualifications});
      await dispatch(addSkillsFromProfile(skillsList, "Qualification Added Skills: " + qualObject.name));
      dispatch(fetchSkillsInfo())
      dispatch(updateReverseMineIndexes())
      dispatch(fetchQualifications())
      return true


      
    } catch (e) {
      logger.error("addQualSkills() error :", e);
    }
  };
}
